import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseConfig } from './../../../../shared/service/base-config.service';
import { GenericHttpService } from './../../../../shared/service/generic-http.service';

@Injectable()
export class ImportarPlanilhaIpmService {
  private readonly urlBase: string;

  constructor(
    private baseConfig: BaseConfig,
    private readonly http: GenericHttpService<any>) {
  }

  ImportarPlanilhaIpm(formData: FormData) {

    let retorno: Observable<any> = null;

    retorno = this.http.UploadArquivo(this.baseConfig.getBaseUrlApi().concat('/ipm/Importar/ExcelUploadPlanilhaIpm'), formData);

    return retorno;
  }

}


// WEBPACK FOOTER //
// ./src/app/ipm/importacao-planilha-ipm/shared/service/importar-planilha-ipm.service.ts